/**
 * Workflow Template Registry
 * Central store for curated automation blueprints.
 */

export const WORKFLOW_CATEGORIES = [
    { id: 'crm', label: 'CRM Operations', icon: 'Settings2' },
    { id: 'governance', label: 'Governance & Logic', icon: 'FileText' },
    { id: 'lifecycle', label: 'Lifecycle Alerts', icon: 'Bell' },
    { id: 'hygiene', label: 'Data Hygiene', icon: 'Layout' }
];

export const WORKFLOW_TEMPLATES = [
    {
        id: 'opp_approval_flow',
        name: 'Opportunity Governance',
        description: 'Notify management and add an audit note when a deal enters negotiation.',
        category: 'governance',
        entityType: 'WORKSPACE_OPPORTUNITY',
        complexity: 'Intermediate',
        trigger: {
            type: 'CRM_EVENT',
            config: { event: 'STAGE_UPDATED', targetStage: 'NEGOTIATION' }
        },
        nodes: [
            { id: 'n1', type: 'SEND_INTERNAL_NOTIFICATION', data: { title: 'Approval Required: [Deal Name]', message: 'A high-value opportunity has reached the Negotiation stage. Please review the terms.' } },
            { id: 'n2', type: 'ADD_NOTE', data: { note: 'Workflow triggered: Approval request sent to management.' } }
        ]
    },
    {
        id: 'important_task_followup',
        name: 'High Priority Escalation',
        description: 'Ensures critical tasks are flagged and internal teams notified of pending actions.',
        category: 'lifecycle',
        entityType: 'WORKSPACE_TASK',
        complexity: 'Simple',
        trigger: {
            type: 'CRM_EVENT',
            config: { event: 'TAG_ADDED', targetTag: 'CRITICAL' }
        },
        nodes: [
            { id: 'n1', type: 'SEND_INTERNAL_NOTIFICATION', data: { title: 'Critical Task Flagged', message: 'A high-priority task requires immediate visibility.' } },
            { id: 'n2', type: 'DELAY_UNTIL_DATE', data: { source: 'FIXED', fixedDate: '' } }, // Placeholder for date
            { id: 'n3', type: 'ADD_NOTE', data: { note: 'Escalated: Critical task remains unresolved after monitoring period.' } }
        ]
    },
    {
        id: 'contact_hygiene_audit',
        name: 'Bulk Contact Cleanup',
        description: 'Set up an annual data hygiene cycle to flag aging contact records.',
        category: 'hygiene',
        entityType: 'WORKSPACE_CONTACT',
        complexity: 'Simple',
        trigger: {
            type: 'MANUAL_ENROLLMENT',
            config: {}
        },
        nodes: [
            { id: 'n1', type: 'DELAY_UNTIL_DATE', data: { source: 'FIELD', fieldPath: 'lastContactedAt' } },
            { id: 'n2', type: 'ADD_NOTE', data: { note: 'Identity verification audit requested for this record.' } }
        ]
    },
    {
        id: 'deal_value_alert',
        name: 'Deal Intelligence Escalation',
        description: 'Automatically reassign and flag high-value opportunities for leadership visibility.',
        category: 'crm',
        entityType: 'WORKSPACE_OPPORTUNITY',
        complexity: 'Advanced',
        trigger: {
            type: 'CRM_EVENT',
            config: { event: 'CREATED' }
        },
        nodes: [
            { id: 'n1', type: 'ASSIGN_OWNER', data: { assignedTo: 'EXPLICIT' } },
            { id: 'n2', type: 'SEND_INTERNAL_NOTIFICATION', data: { title: '🔥 High Value Alert', message: 'A major opportunity was just created. Ownership has been escalated.' } },
            { id: 'n3', type: 'UPDATE_OPPORTUNITY_VALUE', data: { operation: 'SET', amount: 0 } }
        ]
    }
];
